module.exports = __webpack_public_path__ + "static/media/1f914.c58396d2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/emoji/1f914.svg
// module id = 626
// module chunks = 1